module.exports = __webpack_public_path__ + "static/media/VOLTAS.53bf95bb.txt";